module.exports = __webpack_public_path__ + "static/fonts/TitilliumWeb-Bold.a9f517c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TitilliumWeb/TitilliumWeb-Bold.ttf
// module id = UvEi
// module chunks = 0